import React from 'react'
import { Container, Typography, Button, Box } from '@mui/material'
import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <Container 
      maxWidth="md" 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        textAlign: 'center'
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#BF0A30', mb: 2 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Oops! The page you are looking for does not exist.
      </Typography>
      <Box>
        <Button 
          component={Link} 
          to="/" 
          variant="contained" 
          sx={{ backgroundColor: '#BF0A30', '&:hover': { backgroundColor: '#a30d26' } }}
        >
          Go to Home
        </Button>
      </Box>
    </Container>
  )
}
